import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const unrecognizedPersistentBannerSelector = createSelector(testTargetOffersSelector, offers => offers.unrecognizedPersistentBanner || Empty.Object);

export { unrecognizedPersistentBannerSelector };
